import ToolShell, { OutputBlock } from "@/pages/tools/ToolShell";

export default function ReviewResponse() {
  return (
    <ToolShell
      testid="tool-review-page" eyebrow="Pro Tool" toolKey="review" title="Review Response Writer"
      subtitle="Paste a Google or TripAdvisor review. Get three response variants - calm, never defensive."
      endpoint="/tools/review-response" tier="pro" transformPayload={(s) => ({ brief: s })}
      fields={[
        { key: "review_text", label: "Review text", type: "textarea", rows: 5, required: true },
        { key: "context", label: "Anything we should know? (optional)", type: "textarea", rows: 3, placeholder: "e.g. We had a delayed boat that day. The customer was upgraded to a private dive next morning." },
      ]}
      renderOutput={(o) => (
        <>
          <OutputBlock label="Summary">{o.review_summary}</OutputBlock>
          <OutputBlock label="Recommended tone">{o.tone_recommendation}</OutputBlock>
          {(o.responses || []).map((r, i) => (
            <OutputBlock key={i} label={`${r.variant} response`} copyValue={r.text}>
              <div className="whitespace-pre-wrap leading-relaxed">{r.text}</div>
            </OutputBlock>
          ))}
          {o.key_phrases_to_avoid && <OutputBlock label="Phrases to avoid"><ul className="list-disc pl-5 space-y-1">{o.key_phrases_to_avoid.map((p, i) => <li key={i}>{p}</li>)}</ul></OutputBlock>}
        </>
      )}
    />
  );
}
